import { EmailService } from "src/app/services/email/email.service";

import { PescadorService } from "./../../services/solicitante/pescador.service";
import { Pescador } from "../../models/pescador";
import { SubirarchivoService } from "./../../services/subirarchivo/subirarchivo.service";
import {
  Component,
  OnInit,
  AfterViewChecked,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { ListalicenciasService } from "../../services/solicitante/listalicencias.service";
import { Licencia } from "../../models/licencia";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material";
import { SolicitanteService } from "src/app/services/solicitante/solicitante.service";
import { UsuarioService } from "src/app/services/usuario/usuario.service";
import { Solicitante } from "../../models/solictante";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
import { AsignafolioService } from "src/app/services/asigafolios/asignafolio.service";
import { ReciboComponent } from "../recibo/recibo.component";
import { environment } from "src/environments/environment";

import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment";

import { EditorComponent } from "../editor/editor.component";
import { ModulomxService } from "src/app/services/modulomx.service";
import { PgobancarioComponent } from "../pgobancario/pgobancario.component";
import { ReciboprecompraComponent } from "../reciboprecompra/reciboprecompra.component";
import { RecibochequeComponent } from "../recibocheque/recibocheque.component";
import { MovimientospgosService } from "src/app/services/movimientospgos.service";
import { SocketioService } from "src/app/services/socketio.service";

declare let paypal: any;

@Component({
  selector: "app-agencias",
  templateUrl: "./agencias.component.html",
  styleUrls: ["./agencias.component.css"],
})
export class AgenciasComponent implements OnInit, AfterViewChecked {
  @ViewChild("subeArchivo2", { static: true }) subeArchivo2: ElementRef;

  // sta varaible global guardara la cantidad de licencias que se compraran
  licenciassolicitadas = 0;
  // VARIABLES DE PAYPAL
  solicitudhtml = "";
  botondesabilitadopaso5 = true;
  conceptocompralander = "";
  addScript = false;
  paypalLoad = true;
  finalAmount = 0;
  // --------------------

  formGroup: FormGroup;
  cantidadDia = 0;
  cantidadSemana = 0;
  cantidadMes = 0;
  cantidadAno = 0;
  totalpgarPaypal = 0;
  cantidadExcursion = 0;
  nuevonombrearchivo = "";
  licencia: Licencia[];
  precioDia = 10;
  precioSemana = 0;
  precioMes = 0;
  precioAno = 0;
  precioExcursion = 0;
  pagoDeshabilitado: boolean;
  btonopentextbox: boolean;
  MensajemodoMtoo: string = "";

  idempresa: string;

  infosolicitante = "";
  nombresolicitante_ano: string;
  nombresolicitante_semana: string;
  nombresolicitante_dia: string;

  sumatotalDia = 0;
  sumatotalMes = 0;
  sumatotalSemana = 0;
  sumatotalano = 0;
  sumatotalExcursion = 0;
  grantotalPagar = 0;
  uploadCaption = "";
  formasolicitante: FormGroup;
  nombrearchivoCreado: string;
  tipousuario = "";
  usuarioseleccionadoformato = false;

  cadenaMensaje = "";
  bdespliegamensajeadvertencia = false;
  cantidadessolicitadas = "";
  nombre = "";
  email = "";
  telefono = "";
  idusuario = "";
  prioridad: number;
  archivoSubir: File;
  btonOrdenDesactivada: boolean;
  btonPagoDesactivada: boolean;
  botontexteditorDesactivado: boolean;
  btondownloadformdesactivado: boolean;
  info: any;

  categororialicencia: string;

  BoocantidadExcursion: boolean;
  Boocantidadano: boolean;
  Boocantidaddia: boolean;
  Boocantidadsemana: boolean;

  identificador = "";

  nombrepescador: string;
  extensionArchivo: string;
  cantidadsolicitada: number;
  idsolicitantes: string;

  imagenOculta: boolean; // esta variable mostrara el candado que significa formato validado

  tipolicencia: string;
  costolicencia: number;
  fechaInicio: Date;

  ano: string;
  mes: string;
  dia: string;
  idregistro: string;
  solicitante: Solicitante;
  numeroConfirmacionStripe = "";
  folioconsecututivoEfectivo = "";
  nombreArchivoCreado = "";

  firmatemporaldia = false;
  firmatemporalsem = false;
  firmatemporalmes = false;
  firmatemporalano = false;
  firmatemporalexc = false;

  modoMtto: boolean = false;

  almacenaopcionvalidacionoriginal = ""; // esta variable almacenara el valor inicial original de la opcion pedeterminada
  // de la validacion de exceles... servira para cuando el administrador quite o ponga la validacion de manera temporal
  // esta variable almacenara el valor original y posteriormente lo remplazara regresando a la misma opcion predeterminada.
  cambiosenvalidacionexcel = false; // esta variable global almacenara su hubo o no cambios de parte del administrador en cuanto
  // a selecciona la validacion en excel.. inicia en false y cambiara a true cuando el administracion hag cambo en la validacion
  opcionelegida_validacionexcel = ""; // esta variable tomara le valor del permiso dado al cliente sobre la validacion de excel
  // tiene dos valores : permanente... se refiere al que el cambio es definitivo y temporal que el cambio sera solamente de u solo evento

  activarFormato: string;
  buttonDisabled: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private listalicenciasService: ListalicenciasService,
    private dialog: MatDialog,

    private solicitanteService: SolicitanteService,
    private loginUsuario: UsuarioService,
    private subirArchivoService: SubirarchivoService,
    private pescadorService: PescadorService,
    private asignafolioService: AsignafolioService,
    private emailService: EmailService,
    private modulomxService: ModulomxService,
    private spinner: NgxSpinnerService,
    private movimientopgoService: MovimientospgosService,
    private socketService: SocketioService
  ) {}

  // proedimeinots d epaypal
  paypalConfig = {
    // env: 'sandbox',
    // client: {
    //   sandbox: 'AbxtBmb9U5fk2i9bh6oRgfxo4rH0bYiYW_b8rcPWbLSyYc6CCBRZTTu8mnHNrhzglUpNE_viC3Bl8PiX',
    //   production: '<your-production-key here>'
    // },
    // locale: 'en_US',
    // style: {
    //   size: 'large',
    //   color: 'gold',
    //   shape: 'pill',
    //   label: 'pay',
    //   tagline: 'true',
    //   fundingicons: 'true',

    // },

    env: environment.seleccionPago,
    client: {
      sandbox: environment.apiSandbox,
      production: environment.apiProduccion,
    },
    locale: "en_US",
    style: {
      size: "large",
      color: "gold",
      shape: "pill",
      label: "pay",
      tagline: "true",
      fundingicons: "true",
    },

    commit: true,

    payment: (data, actions) => {
      return actions.payment.create({
        payment: {
          transactions: [
            {
              amount: { total: this.finalAmount, currency: "USD" },
              description: "Compra de permisos de Pesca",
            },
          ],
        },
      });
      //     console.log ('aqui otra vez');
    },
    onAuthorize: (data, actions) => {
      return actions.payment.execute().then((payment) => {
        // Do something when payment is successful.
        //   console.log (payment);
        this.numeroConfirmacionStripe = payment.id;

        // aqui se checara la creacin de id unico para controal r lsopagos
        // *************************************************************
        this.asignafolioService.crearFolios().subscribe((resp) => {
          const fechaFolio = resp.fecha;

          const folioconsecutivo = resp.folioconsecutivo;
          this.folioconsecututivoEfectivo = fechaFolio.concat(
            "-",
            folioconsecutivo
          );

          console.log(
            "fecha folio" + folioconsecutivo,
            "---",
            this.folioconsecututivoEfectivo
          );
          console.log(
            "archivo" + this.nombreArchivoCreado,
            "---",
            this.solicitudhtml
          );
          console.log("confirmacionstripe" + this.numeroConfirmacionStripe);

          // aqui actualziare el solicitante a true

          // con esto lo enviare a al proceso de creaccion de licencis

          //   console.log ('nombre del archivo creado desde el servidor', this.nombreArchivoCreado);
          this.solicitanteService
            .solicitanteAceptado(
              this.folioconsecututivoEfectivo,
              this.numeroConfirmacionStripe,
              this.nombreArchivoCreado,
              this.solicitudhtml
            )
            .subscribe((resp) => {
              //  this.show = false;
              //   this.onClose();
              //  this.enviaemail();
              //     console.log (' numero ocnfirmado y ceado');
              //  alert ('numero confirmado');

              this.enviarnotificaciondecompra(
                "Pago por evento  " + this.conceptocompralander
              );

              this.enviaemail();

              return true;
            });
        });

        // aqui se hara le proceso de actualziacion del solicitante

        Swal.fire({
          title: "Payment Confirmation No.",
          text: this.numeroConfirmacionStripe,
          icon: "info",

          confirmButtonText: "Download my receipt now",
          cancelButtonText: "Close window",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.value) {
            this.abrirModal();

            // For more information about handling dismissals please visit
            // https://sweetalert2.github.io/#handling-dismissals
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire("Thanks for your purchase");
            // this.router.navigate(['../fantasma']);
          }
        });
      });
    },
  };

  ngAfterViewChecked(): void {
    if (!this.addScript) {
      this.addPaypalScript().then(() => {
        paypal.Button.render(this.paypalConfig, "#paypal-checkout-btn");
        this.paypalLoad = false;
        //     console.log ('deshabilitado porque no teine nada');
      });
    }
  }

  getRndInteger(min: number, max: number) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  pagoportransferencia() {
    Swal.fire({
      title: "Confirmation",
      text:
        "Click Yes to send your request." +
        "Please forward your bank transfer confirmation details to info@sportfishingmx.com to complete your transaction. Thank you.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        let valoraleatorio: string = this.getRndInteger(100, 100000).toString();
        this.numeroConfirmacionStripe = "Tranf-" + valoraleatorio;

        // aqui se checara la creacin de id unico para controal r lsopagos
        // *************************************************************
        this.asignafolioService.crearFolios().subscribe((resp) => {
          const fechaFolio = resp.fecha;
          //  console.log ('fecha folio' + fechaFolio);
          const folioconsecutivo = resp.folioconsecutivo;
          this.folioconsecututivoEfectivo = fechaFolio.concat(
            "-",
            folioconsecutivo
          );

          // aqui actualziare el solicitante a true

          // con esto lo enviare a al proceso de creaccion de licencis

          //   console.log ('nombre del archivo creado desde el servidor', this.nombreArchivoCreado);
          this.solicitanteService
            .solicitanteAceptado(
              this.folioconsecututivoEfectivo,
              this.numeroConfirmacionStripe,
              this.nombreArchivoCreado,
              this.solicitudhtml
            )
            .subscribe((resp) => {
              //  this.show = false;
              //   this.onClose();
              //  this.enviaemail();
              //     console.log (' numero ocnfirmado y ceado');
              //  alert ('numero confirmado');

              this.enviarnotificaciondecompra(
                "Pago por evento  " + this.conceptocompralander
              );

              this.enviaemail();

              return true;
            });
        });

        // aqui se hara le proceso de actualziacion del solicitante

        Swal.fire({
          title: "Payment Confirmation No.",
          text: this.numeroConfirmacionStripe,
          icon: "info",

          confirmButtonText: "Download my receipt now",
          cancelButtonText: "Close window",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.value) {
            this.abrirModal();

            // For more information about handling dismissals please visit
            // https://sweetalert2.github.io/#handling-dismissals
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire("Thanks for your purchase");
            // this.router.navigate(['../fantasma']);
          }
        });

        //  this.enviaemail();
      }
    });
  }

  pagoscheques() {
    const dialogRefpgobancario = this.dialog.open(PgobancarioComponent, {
      panelClass: "mensaje",
      width: "750px",
      disableClose: true,
      data: {
        costototal: this.grantotalPagar,
      },
    });

    dialogRefpgobancario.afterClosed().subscribe((data) => {
      // this.unsususuarios = this.usuariosptesAceptacion();

      if (data.aceptado != "False") {
        console.log("**************", data);
        let numerocheque = data.numerocheque;
        let valoraleatorio: string = this.getRndInteger(100, 100000).toString();
        this.numeroConfirmacionStripe =
          "#CHEQUE-" + numerocheque + "/" + valoraleatorio;

        this.asignafolioService.crearFolios().subscribe((resp) => {
          const fechaFolio = resp.fecha;
          //  console.log ('fecha folio' + fechaFolio);
          const folioconsecutivo = resp.folioconsecutivo;
          this.folioconsecututivoEfectivo = fechaFolio.concat(
            "-",
            folioconsecutivo
          );

          // aqui actualziare el solicitante a true

          // con esto lo enviare a al proceso de creaccion de licencis

          //   console.log ('nombre del archivo creado desde el servidor', this.nombreArchivoCreado);
          this.solicitanteService
            .solicitanteAceptado(
              this.folioconsecututivoEfectivo,
              this.numeroConfirmacionStripe,
              this.nombreArchivoCreado,
              this.solicitudhtml
            )
            .subscribe((resp) => {
              //  this.show = false;
              this.identificador = resp._id;
              //   this.onClose();
              //  this.enviaemail();
              //     console.log (' numero ocnfirmado y ceado');
              //  alert ('numero confirmado');

              this.enviarnotificaciondecompra(
                "Pago por evento por cheque " + this.conceptocompralander
              );

              this.enviaemail();

              const valorrecibido = this.abrirmodal();

              return true;
            });
        });

        //   this.adquisicionlicencia(this.numeroConfirmacionStripe);
        //esta se habilita para notofocar la compra de lotes
        //  this.enviaemail();
      } else {
        alert("Operation Cancelled");
      }
    });
  }

  addPaypalScript() {
    this.addScript = true;
    //    console.log ('aqui nuevamene');
    return new Promise((resolve, reject) => {
      const scripttagElement = document.createElement("script");
      scripttagElement.src = "https://www.paypalobjects.com/api/checkout.js";
      scripttagElement.onload = resolve;
      document.body.appendChild(scripttagElement);
    });
  }

  // ************************fin paypal

  ngOnInit() {
    const modomantenimiento = async () => {
      let modoto = localStorage.getItem("servidormtto");
      this.MensajemodoMtoo = localStorage.getItem("servidormttotxt");
      this.activarFormato = localStorage.getItem("validarformato"); // esta es la variable que realemnte hace la magia de la validacion
      // el valor es true ... para valiacion completa y false... para sin validacion
      this.almacenaopcionvalidacionoriginal = this.activarFormato; // esta variable guardara el valor de la validacion  y se usara
      // unicamente cuando le administrador quite temporalmente a los clientes la validacion de excel, esta variable restablecera el valor
      // anterior
      this.idempresa = localStorage.getItem("id");

      this.modoMtto = Boolean(JSON.parse(modoto));
      console.log("++++++ mofood mtto", this.modoMtto);
    };

    // aqui asignaremos otra color a lel logo de sportfishing y parpadeando
    modomantenimiento().then(() => {
      //this.formGroup.disable();
      if (this.activarFormato == "true") {
        this.imagenOculta = false;
        this.usuarioseleccionadoformato = true;
      } else {
        this.imagenOculta = true;
        this.usuarioseleccionadoformato = false;
      }

      if (this.MensajemodoMtoo != "nada") {
        Swal.fire(this.MensajemodoMtoo);
      }
    });

    this.usuarioseleccionadoformato = true;
    //  localStorage.setItem('pagina', 'gestor');
    // localStorage.setItem('pagina', 'landing');
    this.subeArchivo2.nativeElement.value = "";
    this.pagoDeshabilitado = true;
    this.totalpgarPaypal = 0;
    //  this.buildForm();

    this.firmatemporaldia = this.loginUsuario.firmatemporaldia;
    this.firmatemporalsem = this.loginUsuario.firmatemporalsem;
    this.firmatemporalmes = this.loginUsuario.firmatemporalmes;
    this.firmatemporalano = this.loginUsuario.firmatemporalano;
    this.firmatemporalexc = this.loginUsuario.firmatemporalexc;

    this.nombre = this.loginUsuario.nombreempresa;
    this.idempresa = this.loginUsuario.idempresa;
    // this.email = this.loginUsuario.usuarioLogin.email;
    this.email = this.loginUsuario.emailempresa;
    //    this.telefono = this.loginUsuario.usuarioLogin.telefono;
    this.btonOrdenDesactivada = true;
    this.btondownloadformdesactivado = true;
    this.btonPagoDesactivada = true;
    this.botontexteditorDesactivado = true;
    this.uploadCaption = "Upload Fishing License Recipient Form";

    this.BoocantidadExcursion = true;
    this.Boocantidadano = true;
    this.Boocantidaddia = true;
    this.Boocantidadsemana = true;
    this.cantidadsolicitada = 0;
    this.idregistro = localStorage.getItem("idsolicitante");
    this.idsolicitantes = localStorage.getItem("idsolicitante");
    this.idusuario = localStorage.getItem("id"); // este es el id del la empresa loggeada
    // this.idregistro  = localStorage.getItem('idsolicitante'); // este es el id del registro concurrente
    //   console.log (' registro de registro ' + this.idregistro);

    // this.prioridad = this.loginUsuario.usuarioLogin.prioridad;
    // console.log ( this.nombre );

    this.listalicenciasService.getLicencias().subscribe((licen) => {
      this.licencia = licen;
      // console.log(this.licencia);
      this.precioDia = this.licencia[0].preciopublico;
      this.precioSemana = this.licencia[1].preciopublico;
      this.precioMes = this.licencia[2].preciopublico;
      this.precioAno = this.licencia[3].preciopublico;
      this.precioExcursion = this.licencia[4].preciopublico;
    });

    this.socketService.listen("modomantenimiento").subscribe((data) => {
      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);

      if (obj.valor == "true") {
        localStorage.setItem("servidormtto", "true");

        localStorage.setItem("servidormttotxt", obj.mensaje);

        this.modoMtto = true;
        Swal.fire(obj.mensaje);
      } else {
        localStorage.setItem("servidormtto", "false");

        localStorage.removeItem("servidormttotxt");

        this.modoMtto = false;
        Swal.fire("Server Online");
      }
    });

    this.socketService.listen("validaormatoexcel").subscribe((data) => {
      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);
      this.cambiosenvalidacionexcel = true;
      this.opcionelegida_validacionexcel = obj.opcion;

      if (obj.valor == true && this.idempresa == obj.idempresa) {
        this.activarFormato = "true";
        this.imagenOculta = false;
        localStorage.setItem("validarformato","true");
        this.usuarioseleccionadoformato = true;
      } else if (obj.valor == false && this.idempresa == obj.idempresa) {
        this.activarFormato = "false";
        this.imagenOculta = true;
        this.usuarioseleccionadoformato = false;
        localStorage.setItem("validarformato","false");
      }
    });
  }

  registrarSolicitante() {
    if (this.infosolicitante == "") {
      Swal.fire({
        icon: "error",

        text: "Last Name Required",
      });
    } else {
      var usuariomx: any;
      this.idusuario = localStorage.getItem("id"); // este es el id del la empresa loggeada
      this.botondesabilitadopaso5 = false;
      this.botontexteditorDesactivado = false;
      this.btondownloadformdesactivado = false;
      this.Boocantidadsemana = true;

      usuariomx = this.loginUsuario.usuariomxatencion;
      if (this.cantidadDia !== 0) {
        if (this.firmatemporaldia) {
          usuariomx = localStorage.getItem("bottemporal");
        }
      } else if (this.cantidadSemana !== 0) {
        if (this.firmatemporalsem) {
          usuariomx = localStorage.getItem("bottemporal");
        }
      } else if (this.cantidadAno !== 0) {
        if (this.firmatemporalano) {
          usuariomx = localStorage.getItem("bottemporal");
        }
      } else if (this.cantidadExcursion !== 0) {
        if (this.firmatemporalexc) {
          usuariomx = localStorage.getItem("bottemporal");
        }
      }

      // console.log ('nombre dle ussuario encontrado', this.idusuario);
      const idvalorusuario = this.idusuario;
      const idregsolicitante = this.idsolicitantes;
      this.btonOrdenDesactivada = true;
      this.solicitante = new Solicitante(
        this.nombre,
        this.email,
        null,
        idvalorusuario,
        null,
        null,
        null,
        1,
        null,
        null,
        null,
        null,
        this.solicitudhtml,
        null,
        null,
        null,
        idvalorusuario,
        null,
        null,
        null,
        "PAGO POR EVENTO-AGENCIAS",
        usuariomx
      );

      this.crearSolicitantes(this.solicitante);
    }
  }

  crearSolicitantes(solicitante: Solicitante) {
    this.solicitanteService.crearSolicitante(solicitante).subscribe((resp) => {
      if (this.cantidadDia !== 0) {
        this.tipolicencia = "Licencia de Dia";
        this.cantidadsolicitada = this.cantidadDia;
      } else if (this.cantidadSemana !== 0) {
        this.tipolicencia = "Licencia de Semana";
        this.cantidadsolicitada = this.cantidadSemana;
      } else if (this.cantidadAno !== 0) {
        this.tipolicencia = "Licencia de año";
        this.cantidadsolicitada = this.cantidadAno;
      } else if (this.cantidadExcursion !== 0) {
        this.tipolicencia = "Licencia de Excursion";
        this.cantidadsolicitada = this.cantidadExcursion;
      } else {
        Swal.fire(
          "Oops...",
          "Please select a license category and enter quantity",
          "error"
        );
        return;
      }

      //     console.log ('csantida comprada:', this.cantidadsolicitada);
      const creacionArchivo = new Date(resp.creado);

      this.ano = JSON.stringify(creacionArchivo.getFullYear());
      this.mes = JSON.stringify(creacionArchivo.getMonth());
      this.dia = JSON.stringify(creacionArchivo.getDay());

      //    this.nombrearchivoCreado = this.ano.concat(this.mes, this.dia, '-', resp.idsolicitante);

      this.idregistro = localStorage.getItem("idsolicitante");
      this.idsolicitantes = localStorage.getItem("idsolicitante");
      //     console.log ('cantidad solicitada', this.cantidadsolicitada);

      const fechaActual = new Date();

      const pescador = new Pescador(
        "LANDING",
        this.tipolicencia,
        "ciudad_desconocida",
        "Estado_desconocido",
        this.cantidadsolicitada + "-" + this.tipolicencia,
        this.grantotalPagar,
        fechaActual,
        this.idsolicitantes,
        this.idregistro,
        this.cantidadsolicitada
      );

      this.pescadorService.crearPescador(pescador).subscribe((resp) => {
        this.btonPagoDesactivada = false;
      });
    });
  }

  private buildForm() {
    this.formGroup = new FormGroup({
      cantidadDia: new FormControl(0),
      cantidadMes: new FormControl(0),
      cantidadAno: new FormControl(0),
      cantidadExcursion: new FormControl(0),
    });
  }

  preciosumatoriaDia(valor) {
    this.categororialicencia = "01";
    this.btonOrdenDesactivada = false;
    this.botondesabilitadopaso5 = true;
    this.uploadCaption = "Upload Passenger Listing Form";
    this.subeArchivo2.nativeElement.value = "";
    this.btonPagoDesactivada = true;

    this.conceptocompralander = "Licencia de pesca por dia";
    if (valor === 0) {
      this.BoocantidadExcursion = false;
      this.Boocantidadano = false;
      this.sumatotalDia = 0;
      this.sumatotalano = 0;
      this.sumatotalExcursion = 0;
    } else {
      this.BoocantidadExcursion = true;
      this.Boocantidadano = true;
    }
    this.cantidadessolicitadas = String(this.cantidadDia);
    this.sumatotalDia = this.cantidadDia * this.precioDia;
    this.grantotalPagar =
      this.sumatotalDia +
      this.sumatotalSemana +
      this.sumatotalMes +
      this.sumatotalano +
      this.sumatotalExcursion;
    this.finalAmount = 0;
  }

  preciosumatoriaSemana(valor) {
    this.categororialicencia = "02";
    this.conceptocompralander = "Licencia de pesca por Semana";
    this.botondesabilitadopaso5 = true;
    this.uploadCaption = "Upload Passenger Listing Form";
    this.subeArchivo2.nativeElement.value = "";
    this.cantidadessolicitadas = String(this.cantidadSemana);

    this.sumatotalSemana = this.cantidadSemana * this.precioSemana;
    this.grantotalPagar =
      this.sumatotalDia +
      this.sumatotalSemana +
      this.sumatotalMes +
      this.sumatotalano +
      this.sumatotalExcursion;
    this.finalAmount = 0;
  }

  preciosumatoriaMes(valor) {
    this.categororialicencia = "03";
    this.botondesabilitadopaso5 = true;
    this.uploadCaption = "Upload Passenger Listing Form";
    this.subeArchivo2.nativeElement.value = "";
    this.cantidadessolicitadas = String(this.cantidadMes);
    this.conceptocompralander = "Licencia de pesca por Mes";
    this.sumatotalMes = this.cantidadMes * this.precioMes;
    this.grantotalPagar =
      this.sumatotalDia +
      this.sumatotalSemana +
      this.sumatotalMes +
      this.sumatotalano +
      this.sumatotalExcursion;

    this.finalAmount = 0;
  }

  demo() {}

  preciosumatoriasemana2(valor) {
    this.categororialicencia = "02";
    this.conceptocompralander = "Licencia de pesca por Semana";
    this.botondesabilitadopaso5 = true;

    this.btonOrdenDesactivada = false;
    if (valor === 0) {
      this.Boocantidadano = false;
      this.Boocantidaddia = false;

      this.sumatotalDia = 0;
      this.sumatotalano = 0;
      this.sumatotalExcursion = 0;
    } else {
      this.Boocantidadano = true;
      this.Boocantidaddia = true;
    }
    this.sumatotalSemana = this.cantidadSemana * this.precioSemana;
    this.grantotalPagar =
      this.sumatotalDia +
      this.sumatotalSemana +
      this.sumatotalMes +
      this.sumatotalano;
  }

  preciosumatoriaExc(valor) {
    this.categororialicencia = "05";
    this.btonOrdenDesactivada = false;
    this.botondesabilitadopaso5 = true;
    this.uploadCaption = "Upload Passenger Listing Form";
    this.subeArchivo2.nativeElement.value = "";
    this.cantidadessolicitadas = String(this.cantidadExcursion);

    if (valor === 0) {
      this.Boocantidadano = false;
      this.Boocantidaddia = false;

      this.sumatotalDia = 0;
      this.sumatotalano = 0;
      this.sumatotalExcursion = 0;
    } else {
      this.Boocantidadano = true;
      this.Boocantidaddia = true;
    }

    this.sumatotalExcursion = this.cantidadExcursion * this.precioExcursion;
    this.grantotalPagar =
      this.sumatotalDia +
      this.sumatotalSemana +
      this.sumatotalMes +
      this.sumatotalano +
      this.sumatotalExcursion;
    this.finalAmount = 0;
  }

  nombresolicitantecapturado_ano(event) {
    this.infosolicitante = this.nombresolicitante_ano;
  }

  nombresolicitantecapturado_semana(event) {
    this.infosolicitante = this.nombresolicitante_semana;
  }

  nombresolicitantecapturado_dia(event) {
    this.infosolicitante = this.nombresolicitante_dia;
  }

  preciosumatoriaAno(valor) {
    this.categororialicencia = "04";
    this.botondesabilitadopaso5 = true;
    this.uploadCaption = "Upload Passenger Listing Form";
    this.subeArchivo2.nativeElement.value = "";

    this.conceptocompralander = "Licencia de pesca por año";
    this.btonOrdenDesactivada = false;
    if (valor === 0) {
      this.BoocantidadExcursion = false;
      this.Boocantidaddia = false;

      this.sumatotalDia = 0;
      this.sumatotalano = 0;
      this.sumatotalExcursion = 0;
    } else {
      this.BoocantidadExcursion = true;
      this.Boocantidaddia = true;
    }
    this.cantidadessolicitadas = String(this.cantidadAno);
    this.sumatotalano = this.cantidadAno * this.precioAno;
    this.grantotalPagar =
      this.sumatotalDia +
      this.sumatotalSemana +
      this.sumatotalMes +
      this.sumatotalano +
      this.sumatotalExcursion;
    this.finalAmount = 0;
  }

  conviertemes(numero: number) {
    let cadena: string;
    cadena = numero.toString();
    const long = cadena.length;
    if (long === 1) {
      return "0" + cadena;
    } else {
      return cadena;
    }
  }

  fechaconvertir() {
    const fechaActual = new Date();
    let year: string;
    let mes: string;
    let dia: string;

    year = fechaActual.toISOString().slice(2, 4);
    mes = this.conviertemes(fechaActual.getMonth() + 1);
    dia = this.conviertemes(fechaActual.getDate());

    return year + mes + dia;
  }

  async SeleccionImagen(event) {
    const file = event.target.files[0];

    const valorfecha = this.fechaconvertir();

    if (this.cantidadDia != 0) {
      this.licenciassolicitadas = this.cantidadDia;
    } else if (this.cantidadSemana != 0) {
      this.licenciassolicitadas = this.cantidadSemana;
    } else if (this.cantidadAno != 0) {
      this.licenciassolicitadas = this.cantidadAno;
    }

    this.nuevonombrearchivo =
      valorfecha +
      "_" +
      this.categororialicencia +
      this.licenciassolicitadas +
      "_" +
      this.nombre +
      "_" +
      this.infosolicitante;
    // alert (file);

    this.archivoSubir = file;
    const id = file.name;
    //     alert (id);
    this.nombrearchivoCreado = id;

    const vnombreArchivofile = JSON.stringify(this.archivoSubir);

    //   console.log (' nombre archivo  lander' , vnombreArchivofile);

    let extensionfile = vnombreArchivofile.indexOf("xlxs");
    //        console.log (extensionfile);

    if (extensionfile === 0) {
      extensionfile = vnombreArchivofile.indexOf("xls"); // en caso de que la extension sea XLS
      if (extensionfile === 0) {
        extensionfile = vnombreArchivofile.indexOf("html"); // en caso de que la extension sea XLS
        if (extensionfile === 0) {
        } else {
          //        alert ('html');
          this.extensionArchivo = "html";
        }
      } else {
        this.extensionArchivo = "xls";
      }
    } else {
      this.extensionArchivo = "xlsx";
    }

    this.spinner.show();

    await this.subirArchivoService
      .subirArchivoyrenombra(
        this.archivoSubir,
        "download",
        id,
        this.nuevonombrearchivo
      )
      .then((resp) => {
        console.log("**************", resp);
        this.info = JSON.stringify(resp);

        this.info = JSON.parse(this.info);

        this.nuevonombrearchivo = this.nuevonombrearchivo.concat(
          ".",
          this.extensionArchivo
        );
        this.uploadCaption = this.nuevonombrearchivo;
        this.spinner.hide();

        console.log("foramto seleccionado", this.usuarioseleccionadoformato);
        // if (this.usuarioseleccionadoformato) {
        if (this.activarFormato) {
          const promesaverificacion = this.verificaxls(
            this.nuevonombrearchivo,
            this.licenciassolicitadas
          );

          promesaverificacion.then((success) => {
            if (success) {
              console.log("************************", success);
              Swal.fire({
                title: "<strong> <u>Request Validation</u></strong>",
                icon: "info",
                html: "<hr>" + "<h5>" + this.cadenaMensaje + "</h5>",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.uploadCaption = "Upload Passenger Listing Form";
                  this.subeArchivo2.nativeElement.value = "";
                }
              });
            }
          });
        }

        this.nombreArchivoCreado = this.nuevonombrearchivo;
        this.finalAmount = this.grantotalPagar;
        this.btonPagoDesactivada = false;
      })
      .catch((resp) => {
        console.log("error", resp);
        this.spinner.hide();
      });
  }

  verificaxls(
    nombreArchivo: string,
    cantidadLicenciasSolicitadas: number
  ): any {
    return new Promise((resolve, reject) => {
      var valorfecha = moment(valorfecha).format("YYYY-MM-DD");

      var despliegamensajeadvertencia = false;
      this.bdespliegamensajeadvertencia = false;

      this.movimientopgoService
        .jsonexcelverificaagenciaxevento(
          nombreArchivo,
          Number(this.cantidadessolicitadas),
          valorfecha
        )
        .subscribe((resp) => {
          console.log(resp);

          this.cadenaMensaje = "";

          if (resp.formato_oficialerroneo) {
            this.bdespliegamensajeadvertencia = true;
            this.cadenaMensaje =
              this.cadenaMensaje +
              ">>Incorrect Excel Request form.  Please use the appropriate form for this type of request.";
          }

          let solicitanteExcel = resp.nombrebarco
            .trim()
            .toUpperCase()
            .replace(/\s/g, "");
          let solicitantecapturado = this.infosolicitante
            .trim()
            .toUpperCase()
            .replace(/\s/g, "");

          if (solicitanteExcel != solicitantecapturado) {
            this.bdespliegamensajeadvertencia = true;
            this.cadenaMensaje =
              this.cadenaMensaje +
              ">>Request name incorrect! in excel : " +
              solicitanteExcel;
          }

          if (Number(cantidadLicenciasSolicitadas) != resp.cuentapasajeros) {
            //  this.bcantidadpasajerosdiferentes = true;
            this.bdespliegamensajeadvertencia = true;
            this.cadenaMensaje =
              this.cadenaMensaje +
              ">> Number of licenses requested and passenger listed do not match, please confirm";
          }

          if (resp.brectificarfechas) {
            this.bdespliegamensajeadvertencia = true;
            this.cadenaMensaje =
              this.cadenaMensaje +
              "<br/> >> Excel file's passenger fishing dates incomplete, missing or already past, please verify. If all is correct, please verify number of 'Fishing Days' to make sure it is in agreement.";
          }

          if (resp.bformatoincompleto) {
            this.bdespliegamensajeadvertencia = true;
            this.cadenaMensaje =
              this.cadenaMensaje +
              "<br/> >> Excel file's passenger listing grid has missing or incomplete information, please verify";
          }

          if (resp.blineasmediasllenas) {
            this.bdespliegamensajeadvertencia = true;
            this.cadenaMensaje =
              this.cadenaMensaje +
              "<br/> >> There is a discrepancy between the number of licenses requested and the passengers listed.  If the information is correct, please delete any extra information on the grid area, such as additional city, state or date listings before saving the excel file  and submitting it again.";
          }
          //*[@id="bots"]/thead/tr[2]/td[2]/button/mat-icon

          if (resp.bcaracteresprohibidos) {
            this.bdespliegamensajeadvertencia = true;
            this.cadenaMensaje =
              this.cadenaMensaje +
              "<br/> >> Special characters, such as asteriks or apostrophes, have been detected in the passengers' names. Please remove any special character, save and reload your passenger list.";
          }

          if (this.categororialicencia === "05") {
            if (resp.tipolicencia.toUpperCase() != "EXCURSION") {
              // if (Number(this.cantidadessolicitadas)<3) {
              //   this.bdespliegamensajeadvertencia = true;
              //   this.cadenaMensaje = this.cadenaMensaje + ">> There is a type mismatch between the licenses requested and the information on the Excel sheet.  Please review and make sure they match"
              // }

              this.bdespliegamensajeadvertencia = true;
              this.cadenaMensaje =
                this.cadenaMensaje +
                ">> There is a type mismatch between the licenses requested and the 'License Category' information on the Excel sheet.  Please review and make sure they match";
            }
          } else {
            if (this.categororialicencia === "04") {
              if (resp.tipolicencia.toUpperCase().indexOf("YEAR") == -1) {
                if (resp.tipolicencia.toUpperCase().indexOf("ANNUAL") == -1) {
                  this.bdespliegamensajeadvertencia = true;
                  this.cadenaMensaje =
                    this.cadenaMensaje +
                    ">> There is a type mismatch between the licenses requested and the 'License Category' information on the Excel sheet.  Please review and make sure they match";
                }
              }
            } else {
              if (this.categororialicencia === "01") {
                if (resp.tipolicencia.toUpperCase().indexOf("DAY") == -1) {
                  this.bdespliegamensajeadvertencia = true;
                  this.cadenaMensaje =
                    this.cadenaMensaje +
                    ">> There is a type mismatch between the licenses requested and the 'License Category' information on the Excel sheet.  Please review and make sure they match";
                }
              } else {
                if (this.categororialicencia === "02") {
                  if (resp.tipolicencia.toUpperCase().indexOf("WEEK") == -1) {
                    this.bdespliegamensajeadvertencia = true;
                    this.cadenaMensaje =
                      this.cadenaMensaje +
                      ">> There is a type mismatch between the licenses requested and the 'License Category' information on the Excel sheet.  Please review and make sure they match";
                  } else {
                    this.bdespliegamensajeadvertencia = true;
                    this.cadenaMensaje =
                      this.cadenaMensaje +
                      ">> There is a type mismatch between the licenses requested and the 'License Category' information on the Excel sheet.  Please review and make sure they match";

                  }
                }
              }
            }
          }

          // if (resp.bverificaceldadllenas) {
          //   this.bdespliegamensajeadvertencia = true;
          //   this.cadenaMensaje =
          //     this.cadenaMensaje +
          //     ">>22There is a discrepancy between the number of licenses requested and the passengers listed.  If the information is correct, please delete any extra information on the grid area, such as additional city, state or date listings before saving the excel file  and submitting it again.";
          // }

          let duplicados = [];

          duplicados = resp.duplicados;
          let cantidadduplicado = duplicados.length;

          if (cantidadduplicado > 0) {
            this.bdespliegamensajeadvertencia = true;
            this.cadenaMensaje =
              this.cadenaMensaje +
              "<br/> >> Duplicate names found, please correct to make sure they are different: <br/>" +
              duplicados;
          }

          resolve(this.bdespliegamensajeadvertencia);
        });
    });

    //  console.log (nombreArchivo);
    //var valorfecha  = this.fechapesca;
  }

  nuevaSolicitud() {
    this.cantidadDia = 0;
    this.cantidadAno = 0;
    this.cantidadExcursion = 0;
    this.cantidadSemana = 0;
    this.cantidadAno = 0;
    this.grantotalPagar = 0;
    this.btonOrdenDesactivada = true;
    this.Boocantidadsemana = true;
    this.nombresolicitante_ano = "";
    this.nombresolicitante_semana = "";
    this.nombresolicitante_dia = "";

    this.infosolicitante = "";

    this.botontexteditorDesactivado = true;
    this.btondownloadformdesactivado = true;
    this.botondesabilitadopaso5 = true;
    this.sumatotalSemana = 0;

    this.sumatotalDia = 0;
    this.sumatotalano = 0;
    this.sumatotalExcursion = 0;
    this.grantotalPagar = 0;

    this.cantidadSemana = 0;

    this.finalAmount = 0;
    this.BoocantidadExcursion = false;
    this.Boocantidaddia = false;
    this.Boocantidadano = false;
    this.Boocantidadsemana = false;
    this.uploadCaption = "Upload Passenger Listing Form";
  }

  abrirModal() {
    this.dialog.open(ReciboComponent, { disableClose: true });
  }

  enviaemail() {
    // const nombreArchivocompleto = this.nombreArchivoPDF;
    const subJet =
      this.nombre +
      " ha realizado un deposito de $" +
      this.grantotalPagar +
      "Dolares";

    // const direccionemail = this.txtemail;
    //   const filepdf = nombreArchivocompleto;

    //  this.nombreArchivoPDF = filepdf;
    this.emailService.sendEmailTuripes(subJet).subscribe((licen) => {
      // alert ('listo');
      // this.botonFinalizadeshabilitado = false;
    });
  }

  abrireditor() {
    const dialogRef = this.dialog.open(EditorComponent, {
      width: "1500px",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((data) => {
      this.solicitudhtml = data;
      if (this.solicitudhtml === "") {
        this.btondownloadformdesactivado = false;
        this.botondesabilitadopaso5 = false;
      } else {
        this.btondownloadformdesactivado = true;
        this.botondesabilitadopaso5 = true;

        this.finalAmount = this.grantotalPagar;

        this.btonPagoDesactivada = false;
      }
    });
  }

  enviarnotificaciondecompra(mensaje: string) {
    // socket envia accion
    this.modulomxService.mensajesolicitudlicencias(this.nombre, mensaje);
  }

  abrirmodal() {
    const dialogRef = this.dialog.open(RecibochequeComponent, {
      panelClass: "mensaje",
      disableClose: true,
      data: {
        identificador: this.identificador,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      console.log("aqui termino");
      this.cerrarventana();
    });
  }

  cerrarventana() {
    console.log("entre a procedimienot cerrrar evntaba");
    // this.dialogRef.close({ aceptado: 'OK', cantidad: this.cantidades, monto: this.totalpagar, nuevoidprecompra: this.ultimoidprecompra, inventariototal: this.inventario });
    // this.dialogRef.close();
  }
}
